module.exports = __webpack_public_path__ + "static/media/download-outline.deb398da.svg";